import {
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth } from "../firebase";

// Codes that mean "the user changed their mind", not a real failure.
const CANCEL_CODES = new Set([
  "auth/popup-closed-by-user",
  "auth/cancelled-popup-request",
  "auth/user-cancelled",
]);

/**
 * Google sign-in via popup. Resolves null when the user closes the popup.
 * The Firestore user doc + Stripe customer are handled centrally in
 * AuthContext on auth state change.
 */
export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  try {
    return await signInWithPopup(auth, provider);
  } catch (err) {
    if (CANCEL_CODES.has(err?.code)) return null;
    throw err;
  }
};

/**
 * Sign in with Apple via popup. Resolves null on user cancel.
 * Requires the Apple provider in Firebase console to be configured
 * with a Services ID + return URL (web flow).
 */
export const signInWithApple = async () => {
  const provider = new OAuthProvider("apple.com");
  provider.addScope("email");
  provider.addScope("name");
  try {
    return await signInWithPopup(auth, provider);
  } catch (err) {
    if (CANCEL_CODES.has(err?.code)) return null;
    throw err;
  }
};
